import { z } from "zod";
import { baseEntity, slugInput, tagsSchema } from "./common.js";

export const prompt = baseEntity.extend({
  /** e.g. "Code review", "Writing", "Debugging", "Planning" */
  useCase: z.string().min(1).max(80),
  title: z.string().min(1).max(200),
  /** The full copy-paste prompt body. */
  body: z.string().min(1),
});
export type Prompt = z.infer<typeof prompt>;

export const promptInput = z.object({
  useCase: z.string().min(1).max(80),
  title: z.string().min(1).max(200),
  body: z.string().min(1),
  slug: slugInput,
  tags: tagsSchema.default([]),
  published: z.boolean().default(true),
  sortOrder: z.number().int().default(0),
});
export type PromptInput = z.infer<typeof promptInput>;

export const promptUpdate = promptInput.partial();
export type PromptUpdate = z.infer<typeof promptUpdate>;
